import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ConfirmEmailPage } from './pages/ConfirmEmailPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { LibraryPage } from './pages/LibraryPage';
import { TeamsPage } from './pages/TeamsPage';
import { InvitationsPage } from './pages/InvitationsPage';

/*
 * The diagrams section is lazy, the scripts library is not.
 *
 * Scripts are the drawer's front page and load on every visit, so splitting them would only add a
 * round trip. Diagrams are a section plenty of people will never open, and their page code plus
 * the document model is about 8 kB gzipped — worth not shipping to everybody. The canvas itself is
 * split again behind this, because React Flow is far larger than the page that hosts it.
 */
const DiagramsPage = lazy(() =>
  import('./pages/DiagramsPage').then((module) => ({ default: module.DiagramsPage })),
);

const DiagramPage = lazy(() =>
  import('./pages/DiagramPage').then((module) => ({ default: module.DiagramPage })),
);

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/confirm-email" element={<ConfirmEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Everything below is signed in, and shares the section rail. */}
      <Route element={<AppShell />}>
        <Route path="/diagrams/:id" element={<DiagramPage />} />
        <Route path="/diagrams" element={<DiagramsPage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/invitations" element={<InvitationsPage />} />

        {/* Last, and a catch-all: the scripts library is the drawer's front page. */}
        <Route path="/*" element={<LibraryPage />} />
      </Route>
    </Routes>
  );
}
